export class DsoEditTexts {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        deletePromtTitle: "Ta bort destineringsområde",
        deletePromptText: "Är du säker på att du vill ta bort destineringsområdet?",
        deleteJa: "Ja, ta bort",
        deleteNej: "Nej, avbryt",
        validationNameRequired: "Området måste ha ett namn.",
        validationNameExists: "Namnet finns redan. Välj ett annat namn.",
        validationNameTooLong: "Namnet är för långt."
    };
}
